
import type {UseFetchOptions} from 'nuxt/app'
import type { FetchOptions } from 'ofetch'

type HttpMethod = 'GET' | 'HEAD' | 'PATCH' | 'POST' | 'PUT' | 'DELETE' | 'CONNECT' | 'OPTIONS' | 'TRACE' |
                  'get' | 'head' | 'patch' | 'post' | 'put' | 'delete' | 'connect' | 'options' | 'trace'

export function useApiFetch<T>(path: string, options: UseFetchOptions<T> = {}) {
  let headers: any = {}
  const runtimeConfig  = useRuntimeConfig();

  return useFetch(runtimeConfig.public.apiUrl + path, {
    //credentials: "include",
    watch: false,
    server: false,  // サーバーサイドでは実行しない
    lazy: false,      // 必要に応じて遅延読み込み
    key: `action-${path}`,
    ...options,
    headers: {
      ...headers,
      ...options?.headers
    },
  });
}

export async function useApiFetchClient<T>(
  path: string,
  options: Omit<FetchOptions, 'method'> & { method?: HttpMethod } = {}
): Promise<T> {
  let headers: any = {}
  const runtimeConfig = useRuntimeConfig()

  return $fetch<T>(runtimeConfig.public.apiUrl + path, {
    // credentials: "include",
    ...options,
    headers: {
      ...headers,
      ...options?.headers
    }
  })
}




/*import type {UseFetchOptions} from 'nuxt/app'
export function useApiFetch<T>(path: string, options: UseFetchOptions<T> = {}) {
  let headers: any = {}
  const runtimeConfig  = useRuntimeConfig();

  return useFetch(runtimeConfig.public.apiUrl + path, {
    //credentials: "include",
    watch: false,
    ...options,
    headers: {
      ...headers,
      ...options?.headers
    }
  });

}
  */
